var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registrar-Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#4B84FF",
    x: 0,
    y: 0,
    width: 16,
    height: 20,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,15.8125 C20,15.928875 20.0525,16.04 20.1465,16.1218125 L22.1465,17.8718125 C22.244,17.957125 22.372,18 22.5,18 C22.628,18 22.756,17.957125 22.8535,17.8718125 L24.8535,16.1218125 C24.9475,16.04 25,15.928875 25,15.8125 L25,4 L20,4 L20,15.8125 Z",
    id: "Fill-4",
    fill: "#4B84FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,0 L23,0 C24.1045695,-2.02906125e-16 25,0.8954305 25,2 L25,3 L20,3 L20,2 C20,0.8954305 20.8954305,2.02906125e-16 22,0 Z",
    id: "Rectangle-6",
    fill: "#4B84FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#FFFFFF",
    transform: "translate(6.000000, 5.000000) scale(1, -1) translate(-6.000000, -5.000000) ",
    x: 2,
    y: 4,
    width: 8,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    fill: "#FFFFFF",
    transform: "translate(6.000000, 9.000000) scale(1, -1) translate(-6.000000, -9.000000) ",
    x: 2,
    y: 8,
    width: 8,
    height: 2,
    rx: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookPen);
export default __webpack_public_path__ + "static/media/BookPen.c8ba8b409c85c2feae362c335ec92650.svg";
export { ForwardRef as ReactComponent };